<script>
  import menus from '$lib/utils/menus.js';
</script>

<div>
  <!-- <div class="grid grid-cols-3 gap-x-12"> -->
  <div class="flex sm:gap-28 justify-around">
    {#each menus as menu}
      {#if menu.children}
        <div>
          <p class="font-medium text-gray-400">{menu.name}</p>
          <ul role="menu" class="mt-14 flex flex-col space-y-6">
            {#each menu.children as menuChild}
              <li role="menuitem" class="flow-root">
                <a href={menuChild.url} class="-m-2 px-2 block text-sm text-gray-600 hover:text-gray-900">{menuChild.name}</a>
              </li>
            {/each}
          </ul>
        </div>
      {/if}
    {/each}
  </div>
</div>
